import React from 'react'
import QuestionTitle from './questionTitle'

const NoticeCard = (props) => {

  return (
    <div className='notice-card'>
      <QuestionTitle question={props.title} />
      <p className='bg-white description'>
        {props.description}
      </p>
    </div>
  )
}

export default NoticeCard
